
    import {Component, Vue} from "vue-property-decorator";

    @Component
    export default class NotFind extends Vue {
        mounted() {
        }
    }
